export default __webpack_public_path__ + "static/media/trice.e036c8af.png";